<template>
  <ul
    class="app-check-group__list"
    :class="`app-check-group__list_${orientation}`"
  >
    <li
      v-for="level in levels"
      :key="level.id"
      class="app-check-group__item"
      :class="`app-check-group__item_${orientation}`"
    >
      <app-checkbox
        :id="level.id"
        :value="level.id"
        :checked="checked.includes(level.id)"
        class="app-check-group__button"
        @check="check"
        @uncheck="uncheck"
      >
        {{ level.text }}
      </app-checkbox>
    </li>
  </ul>
</template>

<script>
import AppCheckbox from '../Base/AppCheckbox';

export default {
  name: 'AppCheckboxGroup',
  components: {
    AppCheckbox,
  },
  model: {
    prop: 'value',
    event: 'changeСheckButton',
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    orientation: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
      checked: this.value,
    };
  },
  methods: {
    check(val) {
      this.checked = [...this.checked, val];
      this.$emit('changeСheckButton', this.checked);
    },
    uncheck(val) {
      this.checked = this.checked.filter((v) => v !== val);
      this.$emit('changeСheckButton', this.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-check-group {
    display: inline-flex;
    align-items: center;

    &__item {
      list-style-type: none;

      &_horizontal {
        display: inline-flex;
        margin-right: 15px;
      }
      &_vertical {
        margin-top: 10px;
      }
    }

    &__list {
      margin: 0;
      &_vertical {
        padding-left: 0;
      }
      &_horizontal {
        padding-left: 15px;
      }
    }

    &__name {
      top: 0;
      font-size: 15px;
    }
  }

</style>
